import React from 'react';
import { Container, Card, Box } from '@material-ui/core';
//import styles from '../Tutos.module.scss';
import couvGuid from '../../../assets/Couv_Guide_RH.jpg';
import { SGSButton, SGSHelpButton } from 'components';

type Props = {};

const GuidePage: React.FC<Props> = () => {
    return (
        <div>
            <SGSHelpButton />
            <Container>
                <Card>
                    <Box display={'flex'} flexDirection={'row'} className="text-center mb-5" style={{ cursor: 'pointer', alignItems: 'stretch' }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Box>
                            <img src={couvGuid} style={{ cursor: 'pointer' }} onClick={() => window.open('/docs/Guide.pdf', '_blank', 'noreferrer')} alt="" />
                        </Box>
                        <Box style={{ cursor: 'pointer', marginTop: '25%' }}>
                            <SGSButton onClick={() => window.open('/docs/Guide.pdf', '_blank', 'noreferrer')}>Télécharger le guide</SGSButton>
                        </Box>
                        <Box sx={{ flex: '1 1 auto' }} />
                    </Box>
                </Card>
            </Container>
        </div>
    );
};

export default GuidePage;
